import {Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';

const {Paragraph, Text} = Typography;
const {Content} = Layout;

const CommunicationColab = () => {
  return (
    <Layout style={{margin: '50px', background: 'inherit'}}>
      <Paragraph className='Title3' style={{color: appColors['ColorX'], marginTop: '-20px'}}>Collaborations</Paragraph>
      <Text className='BaseText'>Throughout the season we made the commitment to connect with other iGEM teams and with specialists in the topics that we were interested in. The collaborations that we successfully achieved were the following:</Text>
      <Layout style={{background: 'inherit', width: 'fit-content', display: 'block'}}>
        <Content style={{float: 'left', background: 'inherit'}}>
          <Paragraph className='Title3' style={{color: appColors['ColorC'], textAlign: 'center'}}>&ensp;iGEM EGYPT&emsp; iGEM UAM&emsp;</Paragraph>
        </Content>
      </Layout>
      <Text className='BaseText'>If you want to know more in detail about our collaborations we invite you to check our exclusive tab for this section: <a href='/tecccm/collaborations'>Collaborations</a> </Text>
    </Layout>
  );
};

export default CommunicationColab;
